import React, { useCallback, useEffect, useState } from 'react'
import {
    Box, Button, Dialog, DialogContent, DialogTitle, Grid, Paper, Typography,
    IconButton, Tooltip, ButtonGroup, Divider
} from '@mui/material'
import CustomDropDown from '../../CustomDropDown'
import CustomTextField from '../../CustomTextField'
import './AddPollTemplate.css'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { buttonStyle, errorTextStyle } from '../../../utils/commonCSS'
import { ECPollTypeOptions, logoOptions, pollTypeOptions } from '../../../utils/constants'
import DeleteIcon from '@mui/icons-material/Delete'
import { headingBlue, maroon, red, pureWhite } from '../../../assets/colors'
import { validateName } from '../../../utils/validations'
import {
    addAttendancePollTemplate, checkWORKerIsEc, createAnElection, editElection,
    getCandidateAndVoterList, getWORKersDesignationWise
} from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import {
    Ballot, Gavel, HowToVote, KeyboardArrowDown, KeyboardArrowUp,
    Close, Poll as PollIcon, QuestionAnswer as QuestionAnswerIcon,
    PeopleAlt as PeopleAltIcon
} from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { showSnackBar } from '../../CustomComponents/CustomComponentsSlice'
import CustomDatePicker from '../../CustomDatePicker'
import dayjs from 'dayjs'
import Loader from '../../Loader'
import _ from 'lodash'
import { useNavigate } from 'react-router-dom'

const AddPollTemplate = (props) => {

    const [name, setName] = useState('')
    const [date, setDate] = useState(dayjs(new Date()))
    const [logo, setLogo] = useState('WORK')
    const [numOfPosts, setNumOfPosts] = useState(1)
    const [dedicatedTo, setDedicatedTo] = useState('All WORKers') // 'All WORKers' | 'Committed WORKers' | 'Supported WORKer'
    const [fields, setFields] = useState([{ 'title': '', options: ['', ''] }])
    const [nameError, setNameError] = useState('')
    const [logoError, setLogoError] = useState('')
    const [dateError, setDateError] = useState('')
    const [numOfPostError, setNumOfPostsErr] = useState('')
    const [fieldError, setFieldError] = useState('')
    const [apiError, setApiError] = useState('')
    const [isEC, setIsEC] = useState(false)
    const [selectedType, setSelectedType] = useState('Poll')
    const [searchText, setSearchText] = useState('')
    const [searchResult, setSearchResult] = useState([])
    const [sectionExpand, setSectionExpand] = useState('sh')
    const [ECList, setECList] = useState([])
    const [ECListErr, setECListErr] = useState('')
    const [CDList, setCDList] = useState([])
    const [CDListErr, setCDListErr] = useState('')
    const [VLList, setVLList] = useState([])
    const [VLListErr, setVLListErr] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const updateType = (value) => {
        setSelectedType(value)
    }

    const updateName = (value) => {
        setName(value)
    }

    const updateLogo = (value) => {
        setLogo(value)
    }

    const updateSearchText = (value) => {
        if (value === "") {
            setSearchText(() => value)
            setSearchResult(() => [])
            debouncedApiCall(value)
        } else {
            setSearchText(() => value)
            debouncedApiCall(value)
        }
    }

    const debouncedApiCall = useCallback(
        _.debounce((query) => {
            if (query !== '') {
                setIsLoading(true)
                let options = {
                    url: getWORKersDesignationWise,
                    method: 'GET',
                    params: {
                        searchText: query
                    },
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                    }
                }

                HttpService(options).then(resp => {
                    setSearchResult(() => resp?.data?.data)
                    setIsLoading(false)
                }).catch(err => {
                    if (err?.status === 403) {
                        localStorage.clear()
                        navigate('/Login')
                    } else {
                        console.log('Error in getting search Result: ', err)
                        setApiError(err?.response?.data?.message)
                        setIsLoading(false)
                    }
                })
            }
        }, 500), []
    )

    const updateNumOfPosts = (value) => {
        if (value >= 1 || value === '')
            setNumOfPosts(value)
        else
            setNumOfPostsErr('Invalid Number of Posts.')
    }

    const updateECList = (member) => {
        let obj = {
            name: member.name,
            contactNumber: member.contactNumber
        }
        if (!ECList.some(item => item.contactNumber === member.contactNumber)) {
            setECList((prev) => [...prev, obj])
        } else {
            dispatch(showSnackBar({ message: 'Member Already in Election Commission.' }))
        }
    }

    const updateCDList = (member) => {
        let obj = {
            name: member.name,
            contactNumber: member.contactNumber
        }
        if (!CDList.some(item => item.contactNumber === member.contactNumber)) {
            setCDList((prev) => [...prev, obj])
        } else {
            dispatch(showSnackBar({ message: 'Member Already in Candidates.' }))
        }
    }

    const updateVLList = (member) => {
        let obj = {
            name: member.name,
            contactNumber: member.contactNumber
        }
        if (!VLList.some(item => item.contactNumber === member.contactNumber)) {
            setVLList((prev) => [...prev, obj])
        } else {
            dispatch(showSnackBar({ message: "Member Already in Voter's List." }))
        }
    }

    const deleteEC = (contactNumber) => {
        let newArray = ECList.filter(obj => obj.contactNumber !== contactNumber)
        setECList(() => newArray)
    }

    const deleteCD = (contactNumber) => {
        let newArray = CDList.filter(obj => obj.contactNumber !== contactNumber)
        setCDList(() => newArray)
    }

    const deleteVL = (contactNumber) => {
        let newArray = VLList.filter(obj => obj.contactNumber !== contactNumber)
        setVLList(() => newArray)
    }

    const addNewField = () => {
        setFields((prev) => [...prev, { title: '', options: ['', ''] }])
    }

    const addNewOption = (index) => {
        setFields(prevFields => prevFields.map((field, i) => (
            i === index ?
                { ...field, options: [...field.options, ''] } : field
        )))
    }

    const updateTitle = (options, title) => {
        setFields(prevFields => prevFields.map((field, i) => (
            i === options.index ?
                { ...field, title: title } : field
        )))
    }

    const updateOption = (options, value) => {
        let prevArray = [...fields]
        prevArray.forEach((ele, index) => {
            if (index === options?.quesIndex) {
                ele['options'][options['index']] = value
            }
        })
        setFields(() => [...prevArray])
    }

    const deleteQuestion = (quesIndex) => {
        let newArray = fields.filter((_, i) => i !== quesIndex)
        setFields(() => [...newArray])
    }

    const deleteOption = (quesIndex, index) => {
        setFields(prevFields => prevFields.map((field, i) => (
            i === quesIndex ?
                { ...field, options: field.options.filter((_, j) => j !== index) } :
                field
        )))
    }

    const validateSubmit = () => {
        let isValid = true

        let nameValidation = validateName(name, 'Name')
        if (nameValidation !== '') {
            setNameError(nameValidation)
            isValid = false
        } else {
            setNameError('')
        }

        if (!date) {
            setDateError('Date cannot be Blank.')
            isValid = false
        } else {
            setDateError('')
        }

        if (!logo) {
            setLogoError('Choose an Option.')
            isValid = false
        } else {
            setLogoError('')
        }

        fields?.forEach((field) => {
            if (!field.title || field.title.trim() === '') {
                setFieldError('Title cannot be Blank.')
                isValid = false
                return
            } else if (!field['options'] || field['options'].length === 0) {
                setFieldError('Each Question Must have Options.')
                isValid = false
                return
            } else {
                field['options'].forEach((option) => {
                    if (option === '') {
                        setFieldError('Option cannot be Blank.')
                        isValid = false
                        return
                    }
                })
            }
        })

        if (isValid) {
            setNameError('')
            setLogoError('')
            setFieldError('')
            setDateError('')
        }

        return isValid
    }

    const AddTemplate = async () => {
        let isValid = validateSubmit()
        if (isValid) {
            setIsLoading(true)
            const targetCategory = dedicatedTo === 'Committed WORKers'
                ? 'committed'
                : (dedicatedTo === 'Supported WORKer' || dedicatedTo === 'Uncommitted WORKers')
                    ? 'unCommitted'
                    : 'all'

            let options = {
                url: addAttendancePollTemplate,
                method: 'POST',
                payload: {
                    programName: name,
                    logo: logo,
                    fields: fields,
                    programDate: date,
                    WORKerCategory: targetCategory
                },
                headers: {
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                    }
                }
            }

            HttpService(options).then((resp) => {
                console.log("New Template Created..")
                setIsLoading(false)
                props.updateDialogStatus(true)
            }).catch(err => {
                setIsLoading(false)
                if (err?.status === 403) {
                    localStorage.clear()
                    navigate('/Login')
                } else {
                    console.log("Error in adding new template.", err)
                    setApiError(err?.response?.data?.message || 'Internal Server Error. Please Contact Support.')
                }
            })
        }
    }

    const validateElectionSubmit = () => {
        let isValid = true

        let nameValidation = validateName(name, 'Name')
        if (nameValidation !== '') {
            setNameError(nameValidation)
            isValid = false
        } else {
            setNameError('')
        }

        if (!date) {
            setDateError('Date cannot be Blank.')
            isValid = false
        } else {
            setDateError('')
        }

        if (numOfPostError !== '') {
            isValid = false
        }

        if (!numOfPosts) {
            setNumOfPostsErr('Posts cannot be Blank.')
            isValid = false
        } else {
            setNumOfPostsErr('')
        }

        if (ECList.length <= 0) {
            setECListErr('Election Commission List cannot be Empty.')
            isValid = false
        } else {
            setECListErr('')
        }

        if (CDList.length <= 0) {
            setCDListErr('Candidates List cannot be Empty.')
            isValid = false
        } else {
            setCDListErr('')
        }

        if (VLList.length <= 0) {
            setVLListErr('Voters List cannot be Empty.')
            isValid = false
        } else {
            setVLListErr('')
        }
        return isValid
    }

    const handleVoteSubmit = () => {
        setIsLoading(true)
        let isValid = validateElectionSubmit()
        if (isValid) {
            let options = {
                url: createAnElection,
                method: 'POST',
                payload: {
                    electionName: name,
                    electionComissionList: ECList,
                    candidateList: CDList,
                    votersList: VLList,
                    programDate: date,
                    numOfPosts: numOfPosts
                },
                headers: {
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }
                }
            }

            HttpService(options).then(resp => {
                console.log("Election Created Successfully.")
                setIsLoading(false)
                props.updateDialogStatus(true)
            }).catch(err => {
                if (err?.status === 403) {
                    localStorage.clear()
                    setIsLoading(false)
                    navigate('/Login')
                } else {
                    console.log("Error in creating Election: ", err)
                    setApiError(err?.response?.data?.message)
                    setIsLoading(false)
                }
            })
        } else {
            setIsLoading(false)
        }
    }

    const editVote = () => {
        setIsLoading(true)
        let isValid = validateElectionSubmit()
        if (isValid) {
            let options = {
                url: editElection + `/${props?.data?._id}`,
                method: 'PUT',
                payload: {
                    numOfPosts: numOfPosts,
                    electionComissionList: ECList,
                    candidateList: CDList,
                    votersList: VLList,
                    programDate: date
                },
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }

            HttpService(options).then(() => {
                setIsLoading(false)
                props.updateDialogStatus(false, true)
            }).catch(err => {
                if (err?.status === 403) {
                    localStorage.clear()
                    setIsLoading(false)
                    navigate('/Login')
                } else {
                    console.log('Error in Editing Election ', err)
                    setApiError(err?.response?.data?.message)
                    setIsLoading(false)
                }
            })
        } else {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        setName('')
        setNameError('')
        setSelectedType('Poll')
        setDate(dayjs(new Date()))
        setDateError('')
        setLogo('WORK')
        setLogoError('')
        setNumOfPosts(1)
        setNumOfPostsErr('')
        setDedicatedTo('All WORKers')
        setFields([{ title: '', options: ['', ''] }])
        setApiError('')
        setFieldError('')
        setIsEC(false)
        setSearchText('')
        setSearchResult([])
        setECList([])
        setECListErr('')
        setCDList([])
        setCDListErr('')
        setVLList([])
        setVLListErr('')
    }, [props?.dialogStatus])

    useEffect(() => {
        setIsLoading(true)
        if (props?.dialogStatus) {
            let options = {
                url: checkWORKerIsEc,
                method: 'GET',
                params: {},
                headers: {
                    authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
            HttpService(options).then(resp => {
                setIsEC(resp?.data?.data?.isEC)
                setIsLoading(false)
            }).catch(err => {
                if (err?.status === 403) {
                    localStorage.clear()
                    setIsLoading(false)
                    navigate('/Login')
                } else {
                    console.log('Error in checking if WORKer is EC: ', err)
                    setApiError(err?.response?.data?.message)
                    setIsLoading(false)
                }
            })
        } else {
            setIsLoading(false)
        }
    }, [props?.dialogStatus])

    useEffect(() => {
        if (props.dialogStatus && props.edit && props.data) {
            setIsLoading(true)
            let options = {
                url: getCandidateAndVoterList + `/${props?.data?._id}`,
                method: 'GET',
                params: {},
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
            HttpService(options).then((resp) => {
                setName(props?.data?.programName || '')
                setDate(props?.data?.programDate ? dayjs(props.data.programDate) : dayjs(new Date()))
                setSelectedType(props?.data?.templateType === 'voting' ? 'Voting' : 'Poll')
                setNumOfPosts(props?.data?.numOfPosts || 1)
                setECList(() => props?.data?.electionCommisionsList || [])
                setCDList(() => resp?.data?.data?.candidateList || [])
                setVLList(() => resp?.data?.data?.voterList || [])

                if (props?.data?.dedicatedTo) {
                    if (props.data.dedicatedTo === 'Uncommitted WORKers') {
                        setDedicatedTo('Supported WORKer')
                    } else {
                        setDedicatedTo(props.data.dedicatedTo)
                    }
                } else if (props?.data?.WORKerCategory) {
                    if (props.data.WORKerCategory === 'committed') setDedicatedTo('Committed WORKers')
                    else if (props.data.WORKerCategory === 'unCommitted' || props.data.WORKerCategory === 'nonCommitted' || props.data.WORKerCategory === 'uncommitted') setDedicatedTo('Supported WORKer')
                    else setDedicatedTo('All WORKers')
                }

                setIsLoading(false)
            }).catch(err => {
                if (err?.status === 403) {
                    localStorage.clear()
                    setIsLoading(false)
                    navigate('/Login')
                } else {
                    console.log('Error in fetching Candidate and Voters List ', err)
                    setApiError(err?.response?.data?.message)
                    setIsLoading(false)
                }
            })
        }
    }, [props.dialogStatus, props.edit, props.data])

    const addField = (title, options, quesIndex) => {
        return (
            <Paper
                key={quesIndex}
                elevation={0}
                sx={{
                    mb: 2,
                    p: 2.2,
                    borderRadius: '10px',
                    border: '1px solid #E2E8F0',
                    backgroundColor: '#ffffff',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                }}
            >
                {/* Question Header */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5, pb: 1, borderBottom: '1px solid #f1f5f9' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            backgroundColor: headingBlue,
                            color: 'white',
                            borderRadius: '4px',
                            px: 1,
                            py: 0.25,
                            fontSize: '0.78rem',
                            fontWeight: 700
                        }}>
                            Q{quesIndex + 1}
                        </Box>
                        <Typography sx={{ fontSize: '0.9rem', fontWeight: 600, color: '#1e293b' }}>
                            Question {quesIndex + 1}
                        </Typography>
                    </Box>

                    {fields?.length > 1 && (
                        <Tooltip title="Delete Question">
                            <IconButton
                                size="small"
                                onClick={() => deleteQuestion(quesIndex)}
                                sx={{ color: red, '&:hover': { backgroundColor: '#fee2e2' } }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>

                {/* Question Title Input */}
                <Box sx={{ mb: 2 }}>
                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#475569', mb: 0.5 }}>
                        Question Title / Prompt
                    </Typography>
                    <CustomTextField
                        value={title}
                        width='100%'
                        placeHolder='e.g., Which program would you prefer for next month?'
                        indexReq={true}
                        options={{ index: quesIndex }}
                        setFunc={updateTitle}
                    />
                </Box>

                {/* Options Section */}
                <Box sx={{ mt: 1.5 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#475569' }}>
                            Options ({options?.length || 0})
                        </Typography>
                        <Button
                            size="small"
                            startIcon={<AddCircleOutlineIcon sx={{ fontSize: '1rem' }} />}
                            onClick={() => addNewOption(quesIndex)}
                            sx={{
                                color: headingBlue,
                                textTransform: 'none',
                                fontSize: '0.78rem',
                                fontWeight: 600,
                                p: '2px 8px',
                                '&:hover': { backgroundColor: '#f0f4f8' }
                            }}
                        >
                            Add Option
                        </Button>
                    </Box>

                    <Grid container spacing={1.5}>
                        {options?.map((option, index) => {
                            let lastIndex = options?.length - 1
                            let isAdd = lastIndex === index
                            return addOption(option, quesIndex, index, isAdd)
                        })}
                    </Grid>
                </Box>
            </Paper>
        )
    }

    const addOption = (option, quesIndex, index) => {
        return (
            <Grid item xs={12} sm={6} key={index}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    p: 0.8,
                    borderRadius: '6px',
                    backgroundColor: '#f8fafc',
                    border: '1px solid #edf2f7'
                }}>
                    <Box sx={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        backgroundColor: '#e2e8f0',
                        color: '#475569',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 700,
                        flexShrink: 0
                    }}>
                        {String.fromCharCode(65 + index)}
                    </Box>

                    <Box sx={{ flex: 1 }}>
                        <CustomTextField
                            placeHolder={`Option ${index + 1}`}
                            value={option}
                            width='100%'
                            indexReq={true}
                            options={{ quesIndex: quesIndex, index: index }}
                            setFunc={updateOption}
                        />
                    </Box>

                    {fields[quesIndex]?.options?.length > 1 && (
                        <Tooltip title="Remove Option">
                            <IconButton
                                size="small"
                                onClick={() => deleteOption(quesIndex, index)}
                                sx={{ color: red, p: '4px', '&:hover': { backgroundColor: '#fee2e2' } }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            </Grid>
        )
    }

    const listsComponent = (config, title) => {
        return (
            <Paper elevation={0} sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 1.5,
                height: '13rem',
                border: '1px solid #E2E8F0',
                borderRadius: '8px',
                backgroundColor: '#ffffff'
            }}>
                <Box sx={{ width: '100%', pb: 0.8, mb: 0.8, borderBottom: '1px solid #f1f5f9' }}>
                    <Typography sx={{ color: headingBlue, fontWeight: 700, fontSize: '0.88rem' }}>{title}</Typography>
                </Box>

                <Box sx={{ width: '100%', flex: 1, overflow: 'auto', pr: 0.5 }}>
                    {config === 'EC' && (
                        ECList.length > 0 ? ECList.map((member, i) => (
                            <Box key={i} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.4, borderBottom: '1px solid #f8fafc' }}>
                                <Box>
                                    <Typography sx={{ fontSize: '0.82rem', fontWeight: 600, color: '#334155' }}>{member.name}</Typography>
                                    <Typography sx={{ fontSize: '0.72rem', color: '#64748b' }}>{member.contactNumber}</Typography>
                                </Box>
                                <IconButton size="small" onClick={() => deleteEC(member.contactNumber)} sx={{ color: red }}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        )) : (
                            <Typography sx={{ ...errorTextStyle, textAlign: 'center', mt: 2 }}>{ECListErr || 'No members added'}</Typography>
                        )
                    )}

                    {config === 'CD' && (
                        CDList.length > 0 ? CDList.map((member, i) => (
                            <Box key={i} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.4, borderBottom: '1px solid #f8fafc' }}>
                                <Box>
                                    <Typography sx={{ fontSize: '0.82rem', fontWeight: 600, color: '#334155' }}>{member.name}</Typography>
                                    <Typography sx={{ fontSize: '0.72rem', color: '#64748b' }}>{member.contactNumber}</Typography>
                                </Box>
                                <IconButton size="small" onClick={() => deleteCD(member.contactNumber)} sx={{ color: red }}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        )) : (
                            <Typography sx={{ ...errorTextStyle, textAlign: 'center', mt: 2 }}>{CDListErr || 'No candidates added'}</Typography>
                        )
                    )}

                    {config === 'VL' && (
                        VLList.length > 0 ? VLList.map((member, i) => (
                            <Box key={i} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.4, borderBottom: '1px solid #f8fafc' }}>
                                <Box>
                                    <Typography sx={{ fontSize: '0.82rem', fontWeight: 600, color: '#334155' }}>{member.name}</Typography>
                                    <Typography sx={{ fontSize: '0.72rem', color: '#64748b' }}>{member.contactNumber}</Typography>
                                </Box>
                                <IconButton size="small" onClick={() => deleteVL(member.contactNumber)} sx={{ color: red }}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        )) : (
                            <Typography sx={{ ...errorTextStyle, textAlign: 'center', mt: 2 }}>{VLListErr || 'No voters added'}</Typography>
                        )
                    )}
                </Box>
            </Paper>
        )
    }

    return (
        <Dialog
            maxWidth='lg'
            fullWidth
            open={props.dialogStatus}
            onClose={() => props.updateDialogStatus(false)}
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    boxShadow: '0 10px 35px rgba(0,0,0,0.15)',
                    overflow: 'hidden'
                }
            }}
        >
            {/* Dialog Header */}
            <DialogTitle sx={{
                backgroundColor: headingBlue,
                color: 'white',
                py: 1.4,
                px: 2.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                    <HowToVote sx={{ color: 'white', fontSize: '1.35rem' }} />
                    <Box>
                        <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '1.05rem', lineHeight: 1.2 }}>
                            {props?.edit ? (selectedType === 'Voting' ? 'Edit Election' : 'Edit Poll Template') : (selectedType === 'Voting' ? 'Create Election' : 'Add New Poll Template')}
                        </Typography>
                        <Typography sx={{ color: 'rgba(255,255,255,0.82)', fontSize: '0.74rem', fontWeight: 400 }}>
                            {selectedType === 'Voting' ? 'Configure election commission, candidates, and voters list' : 'Configure poll details, target WORKers, and questions'}
                        </Typography>
                    </Box>
                </Box>
                <IconButton
                    size="small"
                    onClick={() => props.updateDialogStatus(false)}
                    sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.15)' } }}
                >
                    <Close fontSize="small" />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 2.5, backgroundColor: '#f8fafc' }}>
                {isLoading && <Loader />}

                {/* Section 1: General Details */}
                <Paper
                    elevation={0}
                    sx={{
                        p: 2.5,
                        mb: 2.5,
                        borderRadius: '10px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                    }}
                >
                    <Typography sx={{ fontSize: '0.92rem', fontWeight: 700, color: headingBlue, mb: 1.8, display: 'flex', alignItems: 'center', gap: 0.8 }}>
                        <PollIcon fontSize="small" sx={{ color: headingBlue }} />
                        Poll Settings
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3} sx={{ pointerEvents: props?.edit ? 'none' : 'auto', opacity: props?.edit ? 0.6 : 1 }}>
                            <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#475569', mb: 0.5 }}>Type</Typography>
                            <CustomDropDown
                                regular={true}
                                width='100%'
                                placeHolder='Select Type'
                                value={selectedType}
                                setFunc={updateType}
                                list={isEC ? ECPollTypeOptions : pollTypeOptions}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3} sx={{ pointerEvents: props?.edit ? 'none' : 'auto', opacity: props?.edit ? 0.6 : 1 }}>
                            <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#475569', mb: 0.5 }}>
                                {selectedType === 'Voting' ? 'Election Name' : 'Poll Name'}
                            </Typography>
                            <CustomTextField
                                width='100%'
                                placeHolder={selectedType === 'Voting' ? 'Election Name' : 'Poll Name'}
                                value={name}
                                setFunc={updateName}
                            />
                            {nameError && <Typography sx={{ ...errorTextStyle, textAlign: 'left', mt: 0.5 }}>{nameError}</Typography>}
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#475569', mb: 0.5 }}>Date</Typography>
                            <CustomDatePicker
                                width="100%"
                                selectedDate={date}
                                setSelectedDate={setDate}
                                isNotRestricted={true}
                                minDateValue={dayjs(new Date())}
                            />
                            {dateError && <Typography sx={{ ...errorTextStyle, textAlign: 'left', mt: 0.5 }}>{dateError}</Typography>}
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            {selectedType !== 'Voting' ? (
                                <>
                                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#475569', mb: 0.5 }}>Logo</Typography>
                                    <CustomDropDown
                                        regular={true}
                                        width='100%'
                                        placeHolder='Select Logo'
                                        list={logoOptions}
                                        value={logo}
                                        setFunc={updateLogo}
                                    />
                                    {logoError && <Typography sx={{ ...errorTextStyle, textAlign: 'left', mt: 0.5 }}>{logoError}</Typography>}
                                </>
                            ) : (
                                <>
                                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#475569', mb: 0.5 }}>Number of Posts</Typography>
                                    <CustomTextField
                                        type="number"
                                        width='100%'
                                        placeHolder='Enter Number of Posts'
                                        value={numOfPosts}
                                        setFunc={updateNumOfPosts}
                                    />
                                    {numOfPostError && <Typography sx={{ ...errorTextStyle, textAlign: 'left', mt: 0.5 }}>{numOfPostError}</Typography>}
                                </>
                            )}
                        </Grid>
                    </Grid>

                    {/* Dedicated Audience Option */}
                    {selectedType !== 'Voting' && (
                        <Box sx={{ mt: 2.2, pt: 1.8, borderTop: '1px solid #f1f5f9' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <PeopleAltIcon sx={{ color: headingBlue, fontSize: '1.25rem' }} />
                                    <Box>
                                        <Typography sx={{ fontSize: '0.86rem', fontWeight: 700, color: headingBlue }}>
                                            Dedicated To (Target WORKers)
                                        </Typography>
                                        <Typography sx={{ fontSize: '0.74rem', color: '#64748b' }}>
                                            Select which category of WORKers this poll is dedicated to
                                        </Typography>
                                    </Box>
                                </Box>

                                <ButtonGroup size="small" variant="outlined" sx={{ height: '34px' }}>
                                    <Button
                                        onClick={() => setDedicatedTo('All WORKers')}
                                        variant={dedicatedTo === 'All WORKers' ? 'contained' : 'outlined'}
                                        sx={{
                                            textTransform: 'none',
                                            fontSize: '0.8rem',
                                            fontWeight: 600,
                                            px: 1.8,
                                            backgroundColor: dedicatedTo === 'All WORKers' ? headingBlue : 'white',
                                            color: dedicatedTo === 'All WORKers' ? 'white' : headingBlue,
                                            borderColor: headingBlue,
                                            '&:hover': { backgroundColor: dedicatedTo === 'All WORKers' ? headingBlue : '#f1f5f9' }
                                        }}
                                    >
                                        All WORKers
                                    </Button>

                                    <Button
                                        onClick={() => setDedicatedTo('Committed WORKers')}
                                        variant={dedicatedTo === 'Committed WORKers' ? 'contained' : 'outlined'}
                                        sx={{
                                            textTransform: 'none',
                                            fontSize: '0.8rem',
                                            fontWeight: 600,
                                            px: 1.8,
                                            backgroundColor: dedicatedTo === 'Committed WORKers' ? '#2e7d32' : 'white',
                                            color: dedicatedTo === 'Committed WORKers' ? 'white' : '#2e7d32',
                                            borderColor: '#2e7d32',
                                            '&:hover': { backgroundColor: dedicatedTo === 'Committed WORKers' ? '#2e7d32' : '#f0fdf4' }
                                        }}
                                    >
                                        Committed WORKers
                                    </Button>

                                    <Button
                                        onClick={() => setDedicatedTo('Supported WORKer')}
                                        variant={dedicatedTo === 'Supported WORKer' ? 'contained' : 'outlined'}
                                        sx={{
                                            textTransform: 'none',
                                            fontSize: '0.8rem',
                                            fontWeight: 600,
                                            px: 1.8,
                                            backgroundColor: dedicatedTo === 'Supported WORKer' ? '#ed683c' : 'white',
                                            color: dedicatedTo === 'Supported WORKer' ? 'white' : '#ed683c',
                                            borderColor: '#ed683c',
                                            '&:hover': { backgroundColor: dedicatedTo === 'Supported WORKer' ? '#ed683c' : '#fff7ed' }
                                        }}
                                    >
                                        Supported WORKer
                                    </Button>
                                </ButtonGroup>
                            </Box>
                        </Box>
                    )}
                </Paper>

                {/* Section 2: Poll Questions */}
                {selectedType !== 'Voting' && (
                    <Box sx={{ mb: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                            <Typography sx={{ fontSize: '0.92rem', fontWeight: 700, color: headingBlue, display: 'flex', alignItems: 'center', gap: 0.8 }}>
                                <QuestionAnswerIcon fontSize="small" sx={{ color: headingBlue }} />
                                Poll Questions ({fields?.length || 0})
                            </Typography>

                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={addNewField}
                                sx={{
                                    color: headingBlue,
                                    borderColor: headingBlue,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '0.8rem',
                                    borderRadius: '6px',
                                    '&:hover': { backgroundColor: '#f0f4f8', borderColor: headingBlue }
                                }}
                            >
                                Add Question
                            </Button>
                        </Box>

                        {fields?.map((field, index) => addField(field.title, field.options, index))}
                    </Box>
                )}

                {/* Section 3: Voting / Election Configuration */}
                {selectedType === 'Voting' && (
                    <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: '10px', border: '1px solid #E2E8F0', backgroundColor: '#ffffff' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                {listsComponent('EC', 'Election Commission Members')}
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {listsComponent('CD', 'Candidates')}
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {listsComponent('VL', 'Voters')}
                            </Grid>
                        </Grid>

                        <Box sx={{ width: '100%', mt: 2.5, pt: 2, borderTop: '1px solid #f1f5f9' }}>
                            <Typography sx={{ fontSize: '0.82rem', fontWeight: 600, color: '#475569', mb: 0.8 }}>
                                Search and Assign WORKers
                            </Typography>
                            <CustomTextField
                                placeHolder='Enter name or contact number to search...'
                                value={searchText}
                                width='100%'
                                setFunc={updateSearchText}
                            />

                            {searchResult && Object.keys(searchResult).length > 0 && (
                                <Box sx={{ mt: 2 }}>
                                    {/* State Heads */}
                                    <Box sx={{ mb: 1.5, border: '1px solid #E2E8F0', borderRadius: '8px', overflow: 'hidden' }}>
                                        <Box
                                            onClick={() => setSectionExpand(sectionExpand === 'sh' ? null : 'sh')}
                                            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1, backgroundColor: '#f8fafc', cursor: 'pointer' }}
                                        >
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: headingBlue }}>
                                                State Heads ({searchResult?.stateHead?.length || 0})
                                            </Typography>
                                            {sectionExpand === 'sh' ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
                                        </Box>
                                        {sectionExpand === 'sh' && (
                                            <Box sx={{ maxHeight: '9rem', overflow: 'auto', p: 1 }}>
                                                {searchResult?.stateHead?.map((shead, i) => (
                                                    <Grid container spacing={1} key={i} sx={{ py: 0.6, borderBottom: '1px solid #f1f5f9', alignItems: 'center' }}>
                                                        <Grid item xs={3}><Typography sx={{ fontSize: '0.82rem', fontWeight: 600 }}>{shead.name}</Typography></Grid>
                                                        <Grid item xs={3}><Typography sx={{ fontSize: '0.76rem', color: '#64748b' }}>{shead.contactNumber}</Typography></Grid>
                                                        <Grid item xs={4}><Typography sx={{ fontSize: '0.76rem', color: '#64748b' }}>{shead.district}, {shead.chapter}</Typography></Grid>
                                                        <Grid item xs={2} sx={{ display: 'flex', gap: 0.8 }}>
                                                            <Tooltip title="Add to EC"><IconButton size="small" onClick={() => updateECList(shead)} sx={{ color: headingBlue }}><Gavel fontSize="small" /></IconButton></Tooltip>
                                                            <Tooltip title="Add Candidate"><IconButton size="small" onClick={() => updateCDList(shead)} sx={{ color: '#2e7d32' }}><Ballot fontSize="small" /></IconButton></Tooltip>
                                                            <Tooltip title="Add Voter"><IconButton size="small" onClick={() => updateVLList(shead)} sx={{ color: maroon }}><HowToVote fontSize="small" /></IconButton></Tooltip>
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>

                                    {/* District Heads */}
                                    <Box sx={{ mb: 1.5, border: '1px solid #E2E8F0', borderRadius: '8px', overflow: 'hidden' }}>
                                        <Box
                                            onClick={() => setSectionExpand(sectionExpand === 'dh' ? null : 'dh')}
                                            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1, backgroundColor: '#f8fafc', cursor: 'pointer' }}
                                        >
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: headingBlue }}>
                                                District Heads ({searchResult?.districtHead?.length || 0})
                                            </Typography>
                                            {sectionExpand === 'dh' ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
                                        </Box>
                                        {sectionExpand === 'dh' && (
                                            <Box sx={{ maxHeight: '9rem', overflow: 'auto', p: 1 }}>
                                                {searchResult?.districtHead?.map((dhead, i) => (
                                                    <Grid container spacing={1} key={i} sx={{ py: 0.6, borderBottom: '1px solid #f1f5f9', alignItems: 'center' }}>
                                                        <Grid item xs={3}><Typography sx={{ fontSize: '0.82rem', fontWeight: 600 }}>{dhead.name}</Typography></Grid>
                                                        <Grid item xs={3}><Typography sx={{ fontSize: '0.76rem', color: '#64748b' }}>{dhead.contactNumber}</Typography></Grid>
                                                        <Grid item xs={4}><Typography sx={{ fontSize: '0.76rem', color: '#64748b' }}>{dhead.district}, {dhead.chapter}</Typography></Grid>
                                                        <Grid item xs={2} sx={{ display: 'flex', gap: 0.8 }}>
                                                            <Tooltip title="Add to EC"><IconButton size="small" onClick={() => updateECList(dhead)} sx={{ color: headingBlue }}><Gavel fontSize="small" /></IconButton></Tooltip>
                                                            <Tooltip title="Add Candidate"><IconButton size="small" onClick={() => updateCDList(dhead)} sx={{ color: '#2e7d32' }}><Ballot fontSize="small" /></IconButton></Tooltip>
                                                            <Tooltip title="Add Voter"><IconButton size="small" onClick={() => updateVLList(dhead)} sx={{ color: maroon }}><HowToVote fontSize="small" /></IconButton></Tooltip>
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>

                                    {/* Members */}
                                    <Box sx={{ border: '1px solid #E2E8F0', borderRadius: '8px', overflow: 'hidden' }}>
                                        <Box
                                            onClick={() => setSectionExpand(sectionExpand === 'member' ? null : 'member')}
                                            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1, backgroundColor: '#f8fafc', cursor: 'pointer' }}
                                        >
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: headingBlue }}>
                                                Members ({searchResult?.member?.length || 0})
                                            </Typography>
                                            {sectionExpand === 'member' ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
                                        </Box>
                                        {sectionExpand === 'member' && (
                                            <Box sx={{ maxHeight: '9rem', overflow: 'auto', p: 1 }}>
                                                {searchResult?.member?.map((m, i) => (
                                                    <Grid container spacing={1} key={i} sx={{ py: 0.6, borderBottom: '1px solid #f1f5f9', alignItems: 'center' }}>
                                                        <Grid item xs={3}><Typography sx={{ fontSize: '0.82rem', fontWeight: 600 }}>{m.name}</Typography></Grid>
                                                        <Grid item xs={3}><Typography sx={{ fontSize: '0.76rem', color: '#64748b' }}>{m.contactNumber}</Typography></Grid>
                                                        <Grid item xs={4}><Typography sx={{ fontSize: '0.76rem', color: '#64748b' }}>{m.district}, {m.chapter}</Typography></Grid>
                                                        <Grid item xs={2} sx={{ display: 'flex', gap: 0.8 }}>
                                                            <Tooltip title="Add to EC"><IconButton size="small" onClick={() => updateECList(m)} sx={{ color: headingBlue }}><Gavel fontSize="small" /></IconButton></Tooltip>
                                                            <Tooltip title="Add Candidate"><IconButton size="small" onClick={() => updateCDList(m)} sx={{ color: '#2e7d32' }}><Ballot fontSize="small" /></IconButton></Tooltip>
                                                            <Tooltip title="Add Voter"><IconButton size="small" onClick={() => updateVLList(m)} sx={{ color: maroon }}><HowToVote fontSize="small" /></IconButton></Tooltip>
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            )}
                        </Box>
                    </Paper>
                )}

                {/* Error Banner */}
                {(fieldError || apiError) && (
                    <Box sx={{ mt: 1.5, p: 1.2, backgroundColor: '#fef2f2', borderRadius: '6px', border: '1px solid #fecaca', textAlign: 'center' }}>
                        <Typography sx={{ color: red, fontSize: '0.84rem', fontWeight: 500 }}>
                            {fieldError || apiError}
                        </Typography>
                    </Box>
                )}

                {/* Dialog Footer Actions */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1.5, mt: 2.5, pt: 1.8, borderTop: '1px solid #e2e8f0' }}>
                    <Button
                        variant="outlined"
                        onClick={() => props.updateDialogStatus(false)}
                        sx={{
                            color: '#64748b',
                            borderColor: '#cbd5e1',
                            textTransform: 'none',
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            px: 2.5,
                            py: 0.6,
                            borderRadius: '6px',
                            '&:hover': { borderColor: '#94a3b8', backgroundColor: '#f8fafc' }
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => {
                            selectedType === 'Voting' ?
                                (props?.edit ? editVote() : handleVoteSubmit()) :
                                AddTemplate()
                        }}
                        sx={{
                            ...buttonStyle,
                            margin: 0,
                            textTransform: 'none',
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            px: 3,
                            py: 0.6,
                            borderRadius: '6px',
                            '&:hover': { backgroundColor: headingBlue }
                        }}
                    >
                        {props?.edit ? 'Update' : (selectedType === 'Voting' ? 'Create Election' : 'Add Poll Template')}
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default AddPollTemplate
